import React from 'react';
export function CookiePolicy() {
  return <div className="py-12 bg-white" data-id="element-874">
      <div className="container mx-auto px-4" data-id="element-875">
        <div className="max-w-4xl mx-auto" data-id="element-876">
          <div className="mb-8" data-id="element-877">
            <h1 className="text-3xl font-bold text-slate-900 mb-2" data-id="element-878">
              Cookie Policy
            </h1>
            <p className="text-sm text-slate-500" data-id="element-879">Last Updated: January 2025</p>
          </div>
          <div className="prose prose-slate max-w-none" data-id="element-880">
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-881">
              1. What Are Cookies?
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-882">
              Cookies are small text files that are placed on your computer or
              mobile device when you visit our website. They are widely used to
              make websites work more efficiently and provide information to
              website owners.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-883">
              Cookies allow us to recognize your device and remember information
              about your visit, such as your preferred language and other
              settings. This can make your next visit easier and the site more
              useful to you.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-884">
              2. Types of Cookies We Use
            </h2>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-885">
              2.1 Strictly Necessary Cookies
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-886">
              These cookies are essential for the website to function properly.
              They enable core functionality such as:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4" data-id="element-887">
              <li data-id="element-888">Page navigation and access to secure areas</li>
              <li data-id="element-889">Remembering your cookie consent preferences</li>
              <li data-id="element-890">Maintaining session information</li>
              <li data-id="element-891">Security features and fraud prevention</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-892">
              These cookies do not store any personally identifiable information
              and cannot be disabled as they are essential for the website to
              function.
            </p>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-893">
              2.2 Analytics and Performance Cookies
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-894">
              We use Google Analytics to understand how visitors interact with
              our website. These cookies collect information anonymously and
              report website trends without identifying individual visitors.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-895">
              Information collected includes:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4" data-id="element-896">
              <li data-id="element-897">Number of visitors to the site</li>
              <li data-id="element-898">Pages visited and duration of visits</li>
              <li data-id="element-899">Source of traffic (how visitors arrived at the site)</li>
              <li data-id="element-900">User interactions and click patterns</li>
              <li data-id="element-901">Device and browser information</li>
              <li data-id="element-902">Geographic location (country/city level only)</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-903">
              This information helps us improve our website structure, content,
              and user experience.
            </p>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-904">
              2.3 Functional Cookies
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-905">
              These cookies enable enhanced functionality and personalization,
              such as:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4" data-id="element-906">
              <li data-id="element-907">Remembering your preferences and settings</li>
              <li data-id="element-908">Language and currency preferences</li>
              <li data-id="element-909">Form data to prevent re-entry</li>
            </ul>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-910">
              3. Third-Party Cookies
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-911">
              Some cookies are placed by third-party services that appear on our
              pages. We use the following third-party services:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4" data-id="element-912">
              <li data-id="element-913">
                Google Analytics: For website analytics and performance
                monitoring
              </li>
              <li data-id="element-914">
                Google Tag Manager: For managing website tags and tracking codes
              </li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-915">
              We do not control the cookies set by these third parties. Please
              check the third-party websites for more information about their
              cookies and how to manage them.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-916">
              4. How to Manage Cookies
            </h2>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-917">
              4.1 Cookie Consent Banner
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-918">
              When you first visit our website, you will see a cookie consent
              banner. You can choose to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4" data-id="element-919">
              <li data-id="element-920">Accept all cookies</li>
              <li data-id="element-921">Accept only necessary cookies</li>
              <li data-id="element-922">Customize your cookie preferences</li>
            </ul>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-923">
              4.2 Browser Settings
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-924">
              Most web browsers allow you to control cookies through their
              settings. You can:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4" data-id="element-925">
              <li data-id="element-926">View what cookies are stored on your device</li>
              <li data-id="element-927">Delete existing cookies</li>
              <li data-id="element-928">Block all or specific cookies</li>
              <li data-id="element-929">Set preferences for different websites</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-930">
              Please note that blocking all cookies may impact your experience
              on our website and limit available functionality.
            </p>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-931">
              4.3 Google Analytics Opt-Out
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-932">
              You can opt out of Google Analytics tracking by installing the
              Google Analytics Opt-out Browser Add-on, available at:
              https://tools.google.com/dlpage/gaoptout
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-933">
              5. Cookie Duration
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-934">
              Cookies can be either session cookies or persistent cookies:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4" data-id="element-935">
              <li data-id="element-936">
                Session cookies: Temporary cookies that expire when you close
                your browser
              </li>
              <li data-id="element-937">
                Persistent cookies: Remain on your device for a set period or
                until manually deleted
              </li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-938">
              Your cookie consent preference is stored for 365 days (1 year),
              which is standard for GDPR compliance. After this period, we will
              ask for your consent again.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-939">
              6. Updates to This Cookie Policy
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-940">
              We may update this Cookie Policy from time to time to reflect
              changes in our practices or for legal, regulatory, or operational
              reasons. We encourage you to review this policy periodically to
              stay informed about how we use cookies.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-941">
              The "Last Updated" date at the top of this policy indicates when
              it was last revised. Any changes will become effective when we
              post the revised Cookie Policy on our website.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-942">
              7. Contact Us
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-943">
              If you have questions about our use of cookies or this Cookie
              Policy, please contact us at:
            </p>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-944">
              Email: info@nurahealth.eu
              <br data-id="element-945" />
              Address: [Company Address]
            </p>
          </div>
        </div>
      </div>
    </div>;
}